/** 「今月のお買い上げ金額」の表示フラグ */
export const SHOW_PURCHASE_AMOUNT_KEY = "show-purchase-amount";
